export default __webpack_public_path__ + "static/responsive-brand-presenations@2x-12c71013e393819c9b29a20918a7d674.png";